import { effectSize } from '../../../shared/rules/speciesTraits.mjs';

/**
 * Map token lookups (DM page and character sheet) give each creature a size from its record. A size from a combat
 * effect (Large Form) replaces it, so the token's footprint and every reach check use the creature's current size.
 */
export const applyEffectSizes = (lookup, combatState, normalizeSize) => {
  Object.keys(lookup).forEach((id) => {
    const size = normalizeSize(effectSize(combatState, id));
    if (size) lookup[id] = { ...lookup[id], size };
  });
  return lookup;
};
